"use client"

import { useEffect } from 'react';
import samplesSelectorModel from '@/components/Samples/SamplesSelector/SamplesSelectorModel';
import { useSearchParams } from 'next/navigation';
import { useManagerEntity } from '@/shared/managerHelpers';

// select sample if in url we have somethine like this:
// practice?m=ID
// or 
// play?m=ID
export function useSampleSelection() {
  const searchParams = useSearchParams()
  const sampleId = searchParams.get('m')
  const manager = useManagerEntity();

  useEffect(() => {
    if (sampleId && manager) {
      // if the sampleId in search params is not the same as the selected sample, select it
      samplesSelectorModel.selectSample(sampleId);
    }
  }, [sampleId, manager]);
} 